<template>
  <div>
    <div class="container position-sticky z-index-sticky top-0">
      <div class="row">
        <div class="col-12">
          <!-- Navbar -->
          <nav
            class="navbar navbar-expand-lg blur blur-rounded top-0 z-index-3 shadow position-absolute my-3 py-2 start-0 end-0 mx-4"
          >
            <div class="container-fluid pe-0">  
                <img
                  src="../../core_assets/img/CCD_LOGO_2.png"
                  class="navbar-brand-img img-fluid"
                  alt="main_logo"
                  style="height: 80px !important; width: 80px !important;"
                />
              <button
                class="navbar-toggler shadow-none ms-2"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navigation"
                aria-controls="navigation"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="navbar-toggler-icon mt-2">
                  <span class="navbar-toggler-bar bar1"></span>
                  <span class="navbar-toggler-bar bar2"></span>
                  <span class="navbar-toggler-bar bar3"></span>
                </span>
              </button>
              <div class="collapse navbar-collapse" id="navigation">
                <ul class="navbar-nav mx-auto ms-xl-auto me-xl-7">
                  <!-- <li class="nav-item">
                    <a class="nav-link me-2" href="login">
                      <i class="fas fa-key opacity-6 text-dark me-1"></i>
                      Inicio
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link me-2" href="about">
                      <i class="fas fa-key opacity-6 text-dark me-1"></i>
                      SIFVF
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link me-2" href="About.vue">
                      <i class="fas fa-key opacity-6 text-dark me-1"></i>
                      El equipo
                    </a>
                  </li> -->
                </ul>
                <li class="nav-item d-flex align-items-center">
                  <a
                    class="btn btn-round btn-sm mb-0 btn-outline-primary me-2"
                    href="login"
                    >Accceder</a
                  >
                </li>
                <ul class="navbar-nav d-lg-block d-none"></ul>
              </div>
            </div>
          </nav>
          <!-- End Navbar -->
        </div>
      </div>
    </div>
    <main class="main-content mt-0">
      <section>
        <div class="page-header min-vh-75 mt-6 align-items-center d-flex">
          <div class="container">
            <div class="row">
              <div class="col-lg-2 col-md-3"></div>
              <div class="col-lg-8 col-md-6 ms-lg-8">
                <br /><br />
                <div class="card mt-0">
                  <div class="card-body">
                    <form role="form">
                      <div class="text-center text-muted mb-4">
                        <h2>Registro</h2>
                        <p>Ingresa tus datos personales</p>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <div class="col-md-12">
                            <base-input
                              type="text"
                              label="Nombres"
                              placeholder="Indica tus nombres"
                              v-model="form_save.first_name"
                            >
                            </base-input>
                          </div>
                          <div class="col-md-12">
                            <base-input
                              type="text"
                              label="Apellidos"
                              placeholder="Indica tus apellidos"
                              v-model="form_save.last_name"
                            >
                            </base-input>
                          </div>
                          <div class="col-md-12">
                            <base-input
                              type="text"
                              label="Cédula de identidad / Pasaporte"
                              placeholder="Indica tu cédula o pasaporte"
                              v-model="form_save.dni"
                            >
                            </base-input>
                          </div>
                          <div class="col-md-12">
                            <base-input
                              type="number"
                              label="Teléfono"
                              placeholder="Indica tu teléfono"
                              v-model="form_save.phone"
                            >
                            </base-input>
                          </div>
                          <div class="col-md-12">
                            <label>¿Qué tipo de usuario eres?</label>
                            <multiselect
                              v-model="form_save.id_type_user"
                              label="name"
                              :options="TypeUserTmp"
                              selectLabel="Click/enter para elegir"
                              selectedLabel="Seleccionado"
                              deselectLabel="Click/Enter para remover"
                              select-label="Seleccionar"
                              placeholder="Seleccione"
                              style="
                                border-radius: 30px !important;
                                text-transform: none;
                              "
                            >
                            </multiselect>
                          </div>
                          <div
                            v-if="
                              form_save.id_type_user.id == 1 ||
                              form_save.id_type_user.id == 3
                            "
                            class="col-md-12"
                          >
                            <base-input
                              type="text"
                              label="ID de entrenador"
                              placeholder="Indica tu ID de entrenador"
                              v-model="form_save.id_rne"
                            >
                            </base-input>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="col-md-12">
                            <base-input
                              type="email"
                              label="Correo"
                              placeholder="Indica tu correo"
                              v-model.trim="form_save.email"
                            >
                            </base-input>
                          </div>
                          <div class="col-md-12">
                            <base-input
                              type="password"
                              label="Contraseña"
                              placeholder="Indica tu contraseña"
                              v-model="form_save.password"
                            >
                            </base-input>
                          </div>
                          <div class="col-md-12">
                            <base-input
                              v-if="form_save.password"
                              type="password"
                              label="Repite la contraseña"
                              placeholder="Confirma tu contraseña"
                              v-model="form_save.password2"
                            >
                            </base-input>
                            <base-input
                              v-else
                              type="password"
                              label="Repite la contraseña"
                              placeholder="Confirma tu contraseña"
                              v-model="checkEmptyPassword"
                              disabled
                            >
                            </base-input>
                          </div>

                          <div class="col-md-12">
                            <label>País</label>
                            <multiselect
                              v-model="form_save.id_country"
                              label="name"
                              :options="sortedCountryTmp"
                              selectLabel="Click/enter para elegir"
                              selectedLabel="Seleccionado"
                              deselectLabel="Click/Enter para remover"
                              select-label="Seleccionar"
                              placeholder="Seleccione"
                              @input="loadState()"
                              style="
                                border-radius: 30px !important;
                                text-transform: capitalize;
                              "
                            >
                            </multiselect>
                          </div>

                          <div class="col-md-12">
                            <label>Estado</label>
                            <multiselect
                              v-model="form_save.id_state"
                              label="name"
                              :options="StateTmp"
                              selectLabel="Click/enter para elegir"
                              selectedLabel="Seleccionado"
                              deselectLabel="Click/Enter para remover"
                              select-label="Seleccionar"
                              placeholder="Seleccione"
                              style="
                                border-radius: 30px !important;
                                text-transform: capitalize;
                              "
                              :disabled="!form_save.id_country"
                            >
                            </multiselect>
                            <p
                              v-if="!form_save.id_country"
                              style="
                                color: rgb(184, 49, 49);
                                text-transform: none !important;
                                font-size: 11px;
                              "
                            >
                              Debe seleccionar un Pais para seleccionar un
                              Estado
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12 mt-4">
                          <div class="text-center">
                            <button
                              type="button"
                              class="btn bg-gradient-fvf"
                              @click="saveUser"
                            >
                              <span>Registrarse</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-md-3"></div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <!-- -------- START FOOTER 3 w/ COMPANY DESCRIPTION WITH LINKS & SOCIAL ICONS & COPYRIGHT ------- -->
    <layout-footer></layout-footer>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import LayoutFooter from "./Layouts/Footer";
import { mapActions } from "vuex";
import Multiselect from "vue-multiselect";
import EmailValidator from "email-validator";

// Add the missing CSS styles for the Multiselect component
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  name: "register",
  components: {
    Multiselect,
    LayoutFooter,
  },
  data() {
    return {
      form_save: {
        dni: "",
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        password2: "",
        phone: "",
        id_country: "",
        id_state: "",
        id_type_user: "",
        id_rne: "",
      },

      TypeUserTmp: [
        { id: 1, name: "Entrenador" },
        { id: 2, name: "Jugador retirado" },
        { id: 3, name: "Entrenador y Jugador retirado" },
        { id: 0, name: "Ninguno de los anteriores" },
      ],

      CountryTmp: [],
      StateTmp: [],
    };
  },
  mounted() {
    this.loadCountry();
    this.loadState();
  },
  computed: {
    sortedCountryTmp() {
      return this.CountryTmp.sort((a, b) => a.name.localeCompare(b.name));
    },

    checkEmptyPassword() {
      if (!this.form_save.password) {
        return (this.form_save.password2 = "");
      }
    },
  },
  methods: {
    ...mapActions(["login", "getData", "createData", "recoverData", "getRegisterData"]),

    mailValidator() {
      let validate = EmailValidator.validate(this.form_save.email);
      if (!validate) {
        Swal.fire({
          title: "Email inválido",
          text: "Debes escribir un email válido para poder continuar",
          icon: "warning",
        });
      }
    },

    saveUser() {
      this.mailValidator();
      if (
        !this.form_save.id_country &&
        !this.form_save.id_state &&
        !this.form_save.first_name &&
        !this.form_save.last_name &&
        !this.form_save.email &&
        !this.form_save.password &&
        !this.form_save.password2 &&
        !this.form_save.phone &&
        !this.form_save.dni &&
        !this.form_save.id_type_user
      ) {
        Swal.fire({
          title: "Completa los datos",
          text: "Debes completar todos los datos para registrarte",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
      } else if (this.form_save.password.length < 8) {
        Swal.fire({
          title: "Contraseña inválida",
          text: "La contraseña debe tener al menos 8 caracteres",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
      } else if (
        (this.form_save.id_type_user.id == 1 && !this.form_save.id_rne) ||
        (this.form_save.id_type_user.id == 3 && !this.form_save.id_rne)
      ) {
        Swal.fire({
          title: "Ingrese su ID de entrenador",
          text: "Si es entrenador debe ingresar su ID de entrenador.",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
      } else if (this.form_save.password === this.form_save.password2) {
        Swal.fire({
          title: "Registro de usuario",
          text: "¿Estás seguro de realizar el registro?",
          icon: "question",
          reverseButtons: true,
          showCancelButton: true,
          confirmButtonColor: "#B49B57",
          cancelButtonColor: "#abb2ba",
          cancelButtonText: "Cancelar",
          confirmButtonText: "Si, registrar",
        }).then((result) => {
          if (result.value) {
            this.deleting = true;

            let form = {
              url: "auth/user/register",
              data: {
                first_name: this.form_save.first_name,
                last_name: this.form_save.last_name,
                password: this.form_save.password,
                email: this.form_save.email,
                phone: this.form_save.phone,
                dni: this.form_save.dni,
                id_country: this.form_save.id_country.id,
                id_state: this.form_save.id_state.id,
                id_type_user: this.form_save.id_type_user.id,
                id_rne: this.form_save.id_rne,
              },
            };

            this.recoverData(form)
              .then((response) => {
                if (response.code === 200) {
                  this.deleting = false;
                  Swal.fire({
                    title: "Registro completado",
                    text: "Gracias por registrarte en CCD",
                    icon: "success",
                    showConfirmButton: true,
                    showLoaderOnConfirm: true,
                  }).then((result) => {
                    this.$router.push("login");
                  });
                }

                if (response.code === 409) {
                  this.deleting = false;
                  Swal.fire({
                    title: "Ya existe un usuario con estos datos",
                    icon: "warning",
                    sshowConfirmButton: true,
                    showLoaderOnConfirm: true,
                  });

              
                  // this.$router.push("registro");
                }

                

                if (response.code === 410) {
                  this.deleting = false;
                  Swal.fire({
                    title: "Ya existe un usuario con este RNE",
                    icon: "warning",
                    sshowConfirmButton: true,
                    showLoaderOnConfirm: true,
                  });
                }

                if (response.code === 408) {
                  this.deleting = false;
                  Swal.fire({
                    title: "Ya existe un usuario con este correo",
                    icon: "warning",
                    sshowConfirmButton: true,
                    showLoaderOnConfirm: true,
                  });
                  // this.$router.push("registro");
                }

                if (response.code === 403) {
                  this.deleting = false;
                  Swal.fire({
                    title: "Ya existe otro usuario con este teléfono",
                    icon: "warning",
                    showConfirmButton: true,
                    showLoaderOnConfirm: true,
                  });
                  // this.$router.push("registro");
                }
              })
              .catch((error) => {
                console.log(error);
                this.deleting = false;
                alert("Ocurrió un error, intente más tarde");
              });
          }
        });
      } else {
        this.deleting = false;
        Swal.fire({
          title: "Contraseñas diferentes",
          text: "Chequee los datos.",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 4000,
        });
        this.$router.push("registro");
      }
    },

    loadCountry() {
      let form = {
        url: "master/country/all",
        params: {
          order_key: "asc",
          order_by: "name",
          active: 1,
        },
      };

      this.isBusy = true;
      this.getRegisterData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.CountryTmp = response.data;
            this.loadState();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadState() {
      let form = {
        url: "master/state/all",
        params: {
          order_key: "asc",
          order_by: "name",
          active: 1,
          id_country: this.form_save.id_country
            ? this.form_save.id_country.id
            : null,
        },
      };

      this.isBusy = true;
      this.getRegisterData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.StateTmp = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

  },
};
</script>
<style>
.gradient-custom-2 {
  /* fallback for old browsers */
  background: #fccb90;

  /* Chrome 10-25, Safari 5.1-6 */
  background: -webkit-linear-gradient(
    to right,
    #ee7724,
    #d8363a,
    #dd3675,
    #b44593
  );

  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background: linear-gradient(to right, #ee7724, #d8363a, #dd3675, #b44593);
}

@media (min-width: 768px) {
  .gradient-form {
    height: 100vh !important;
  }
}

@media (min-width: 769px) {
  /* .gradient-custom-2 {
    border-top-right-radius: .3rem;
    border-bottom-right-radius: .3rem;
  } */
}

body {
  font-family: "Jost" !important;
  /* text-transform: uppercase !important; */
}

.card .card-body {
  font-family: "Jost" !important;
}

.page-header .container {
  margin: 0px;
  padding: 0px;
  z-index: 0;
}

.fvf_background {
  /* background-image: url("../../../public/img/login-fondo.jpg");  */
  background-color: rgb(53, 16, 32, 0.8) !important;
  backdrop-filter: blur(2px);
  /* Add the blur effect */
  height: 100%;
  width: 100%;
  top: 0%;
  position: absolute;
}
.fvf_img {
  background-image: url("../../../public/img/login-fondo.jpg");
  /* Center and scale the image nicely */
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  width: 100%;
  top: 0%;
  position: absolute;
}

.fvf_logo {
  filter: blur(0px) !important;
  z-index: 5;
  position: absolute;
  top: 0%;
  left: -4%;
}

.form-control {
  border-radius: 30px !important;
}

.btn {
  border-radius: 30px !important;
  box-shadow: 0 4px 7px -1px #b49b57, 0 2px 4px -1px #b49b57 !important;
}

.bg-gradient-fvf {
  background-color: rgb(53, 16, 32) !important;
  color: white !important;
}

.bg-gradient-fvf-switch {
  background-color: white;
  color: rgb(53, 16, 32);
}

.text-gradient-fvf {
  color: rgb(53, 16, 32);
}

.text-fvf {
  color: #b49b57;
}

.multiselect__tags {
  border-radius: 30px !important;
}

.multiselect__content-wrapper {
  border-radius: 30px !important;
  position: absolute;
  z-index: 1;
}

/* .swal2-container.swal2-center > .swal2-popup {
  background-color:#541A32 !important;
  color: #B49B57 !important;
   
} */

.swal2-container.swal2-center > .swal2-popup {
  z-index: 10000 !important;
}

.swal2-container {
  z-index: 10000 !important;
}

.swal2-styled.swal2-confirm {
  background-color: #541a32 !important;
  color: white !important;
  border-radius: 30px !important;
  z-index: 10000 !important;
}

.swal2-styled.swal2-cancel {
  border-radius: 30px !important;
  z-index: 10000 !important;
}

.btn:hover:not(.btn-icon-only) {
  box-shadow: 0 3px 5px -1px rgb(53, 16, 32), 0 2px 3px -1px rgb(53, 16, 32) !important;
  transform: scale(1.02) !important;
  background-color: #b49b57 !important;
  color: rgb(53, 16, 32) !important;
}

.btn-info:hover {
  color: rgb(53, 16, 32) !important;
  background-color: white !important;
  border-color: rgb(53, 16, 32) !important;
}

.btn-info {
  border-color: #b49b57 !important;
}

.btn-info {
  --bs-btn-border-color: #b49b57 !important;
  --bs-btn-hover-border-color: #b49b57 !important;
  --bs-btn-active-border-color: #b49b57 !important;
  --bs-btn-disabled-border-color: #b49b57 !important;
}

.swal2-styled.swal2-confirm:focus {
  box-shadow: 0 0 0 3px #b49b57 !important;
}

.btn.focus,
.btn:focus {
  box-shadow: 0 0 0 0.2rem #b49b57 !important;
}

.page-item.active .page-link {
  background-color: rgb(53, 16, 32) !important;
  border-color: #b49b57 !important;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.btn-check:checked + .btn,
:not(.btn-check) + .btn:active,
.btn:first-child:active,
.btn.active,
.btn.show {
  background-color: #b49b57 !important;
  color: white !important;
}
.multiselect__option--highlight {
  background: #b49b57 !important;
  background-color: #b49b57 !important; /* Cambiar el color a vinotinto */
}

.multiselect__option--highlight:after {
  background: #b49b57 !important; /* Cambiar el color a vinotinto */
}
.multiselect__option--selected.multiselect__option--highlight {
  background: rgb(53, 16, 32) !important; /* Cambiar el color a vinotinto */
}
.multiselect__option--selected.multiselect__option--highlight:after {
  background: rgb(53, 16, 32) !important; /* Cambiar el color a vinotinto */
}

.rif-number {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}

.rif-prefix {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.rif-number .form-control {
  border-top-right-radius: 30px !important;
  border-bottom-right-radius: 30px !important;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  height: 40px !important;
  margin-top: 1px !important;
}

.rif-prefix .multiselect__tags {
  border-top-left-radius: 30px !important;
  border-bottom-left-radius: 30px !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.rif-prefix .multiselect__content-wrapper {
  border-top-left-radius: 30px !important;
  border-bottom-left-radius: 30px !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}
</style>
